import React from 'react';
import { NavigationStepperItemType } from './NavigationStepper';
import { joinClasses } from '../../Utils/className.util';
import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './NavigationStepperItem.module.scss';

export interface NavigationStepperItemProps {
	activeKey?: string;
	item: NavigationStepperItemType;
	onChange: (step: NavigationStepperItemType) => void;
	route?: NavigationStepperItemType;
	showStepNumbers?: boolean;
	firstUpper?: boolean;
}

const NavigationStepperItem: React.FC<NavigationStepperItemProps> = props => {
	const { item, onChange, activeKey, showStepNumbers = true } = props;

	const handleSetActive = (step: NavigationStepperItemType) => {
		onChange(step);
	};

	return (
		<div
			className={joinClasses([
				styles.item,
				activeKey === item.key && styles.active,
				activeKey != item.key && item.disabled ? styles.disabled : undefined,
			])}
			onClick={() => handleSetActive(item)}>
			<div
				className={joinClasses([
					styles.title,
					showStepNumbers ? '' : styles.noBefore,
				])}>
				<Text tx={item.name} inline={true} />
			</div>
		</div>
	);
};

export default NavigationStepperItem;
